import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withTranslation} from "react-i18next";


class AsyncAutocomplete extends React.Component {

    constructor() {
        super();
        this.state = {
            open: false,
            options: []
        }
    }

    async componentDidMount() {
        if (this.props.serviceSubject && this.props.formID === "serviceSubjectName") {
            await this.loadInitialValue(this.props.serviceSubject);
        }
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.serviceSubject !== this.props.serviceSubject) {
            if (this.props.serviceSubject && this.props.formID === "serviceSubjectName") {
                await this.loadInitialValue(this.props.serviceSubject);
            }
        }
    }

    loadInitialValue = async (serviceSubjectName) => {
        let options = await this.fetchOptions(serviceSubjectName)
        if (options) {
            let serviceSubject = options.find(item => item.description.toLowerCase() === serviceSubjectName.toLowerCase());
            if (serviceSubject)
                this.setState({serviceSubject})
        }
        this.setState({open: false})
    }
    fetchOptions = async (text) => {
        const {t} = this.props
        let {source} = this.props;
        if (text != '')
            this.setState({open: true, loading: true})
        else
            this.setState({open: false})
        const response = await source(text);
        if (response) {
            this.setState({options: response, loading: false, serviceSubject: null})
            return response
        } else
            this.setState({options: [t('noServiceFound')], loading: false})
    }

    setOpen = (value) => {
        this.setState({open: value, loading: value});
    }

    render() {
        const {style, label, formID, updateForm} = this.props;
        const {open, options, loading, serviceSubject} = this.state;
        const setOpen = this.setOpen;
        return (
            <Autocomplete
                ref={ref => this.autocomplete = ref}
                popupIcon={""}
                id="asynchronous-demo"
                open={open}
                onOpen={() => {
                    //setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                getOptionSelected={(option, value) => option === value}
                getOptionLabel={option => option.description}
                onInputChange={(input) => this.fetchOptions(input.target.value)}
                options={options}
                onChange={(event, value) => {
                    this.setState({serviceSubject: value})
                    updateForm(formID, value)
                }
                }
                loading={loading}
                filterOptions={options => options}
                renderInput={params => (
                    <div className={formID === "serviceSubjectName" && serviceSubject ? "black-label" : ""}>
                        <TextField
                            {...params}
                            placeholder={this.props.placeholder}
                            label={formID === "serviceSubjectName" && serviceSubject ? serviceSubject.description : label}
                            fullWidth
                            variant="outlined"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <React.Fragment>
                                        {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                ),
                            }}
                        />
                    </div>
                )}
            />
        );
    }
}


export default withTranslation('translation')(AsyncAutocomplete)
